import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
export const EmptyTxt = styled.p`
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(22)};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 32px;
`;
